/** Which session's chat is on screen right now, so the heads-up pop-up stays quiet about asks the chat already shows. */
let onScreen: string | null = null;

export function chatShown(sessionId: string): () => void {
  onScreen = sessionId;
  return () => {
    if (onScreen === sessionId) onScreen = null;
  };
}

export const chatOnScreen = (sessionId: string): boolean => onScreen === sessionId;
